import BasePage from './BasePage';
import { connect } from 'react-redux';
import {setModalContent} from '../actionCreators';
import Menu from '../components/Menu';
import Modal from '../components/Modal';
import $ from 'jquery';

class EditLocation extends BasePage {

    loadOnConstructor(){
		this.getLocationInterface = this.getLocationInterface.bind(this);
		this.cancelButton = this.cancelButton.bind(this);
		this.saveButton = this.saveButton.bind(this);
		this.updateLocationCallback = this.updateLocationCallback.bind(this);
		this.newLocationCallback = this.newLocationCallback.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.parseResponse = this.parseResponse.bind(this);
		this.stringBackToStringFront = this.stringBackToStringFront.bind(this);

		const {location_id} = this.getUrlParams();
		if(location_id !== undefined){
			this.state = {action: 'modify'};
			this.getLocationInterface(location_id);
		}else{
			this.state = {action: 'new', isSaving: false};
			this.getLocationInterface();
		}
    }

    getLocationInterface(locationId){
		const api = this.getApi();
		api.getEditLocationInterface(locationId, this.parseResponse);
    }

    parseResponse(response){
		if(response.hasOwnProperty('auth') && response.auth === false){
			this.navigateTo('/login');
			return;
		}

		if(response.status === 'OK'){
			if(this.state.action === 'modify'){
				response.location.creation_date = this.stringBackToStringFront(response.location.creation_date);
				response.location.modification_date = this.stringBackToStringFront(response.location.modification_date);

				this.setState(prevState => {
					return {
						...prevState,
						location: response.location,
						i18n: response.i18n
					}
				});
			}else{
				this.setState(prevState => {
					return {
						...prevState,
						location: response.location,
						i18n: response.i18n
					}
				});
			}
		}else{
			this.props.setModalContent({
				title: this.getTrad('messageFromServer'),
				body: [this.getTrad(response.message)],
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true }
				]
			});

			$("#exampleModal").modal('toggle');
			return;
		}
	}

	stringBackToStringFront(originalStr){
		const objDate = new Date(originalStr);

		return objDate.getUTCFullYear() + "-" +
			("0" + (objDate.getUTCMonth()+1)).slice(-2) + "-" +
			("0" + objDate.getUTCDate()).slice(-2) + " " +
			("0" + objDate.getUTCHours()).slice(-2) + ":" +
			("0" + objDate.getUTCMinutes()).slice(-2) + ":" +
			("0" + objDate.getUTCSeconds()).slice(-2);
	}

	cancelButton(){
		this.goBack();
    }

    saveButton(){

		let failedValidators = {};

		if($('#name').val() === ''){
			failedValidators.name = this.getTrad('fillLocationName');
		}

		if(Object.keys(failedValidators).length !== 0){
			let message = [];
			for (let m in failedValidators){
				message.push(failedValidators[m]);
			}
			this.props.setModalContent({
				title: 'Debe completar los datos obligatorios',
				body: message,
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true }
				]
			});

			$("#exampleModal").modal('toggle');
			return;
		}

		this.setState({ isSaving: true })
		const api = this.getApi();
		if(this.state.action === 'modify'){
				api.updateLocation(this.state.location,this.updateLocationCallback);
		}else{
				api.newLocation(this.state.location,this.newLocationCallback);
		}
    }

    updateLocationCallback(response){
		this.setState({ isSaving: false })
	    if(response.status === 'OK'){
		    this.props.setModalContent({
			    title: this.getTrad('messageFromServer'),
			    body: ['La delegación ha sido modificada satisfactoriamente.'],
			    buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
			    ]
		    });

		    $("#exampleModal").modal('toggle');
	    }else{
		    this.props.setModalContent({
			    title: this.getTrad('messageFromServer'),
			    body: [this.getTrad(response.message)],
			    buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true}
			    ]
		    });

		    $("#exampleModal").modal('toggle');

	    }
    }

    newLocationCallback(response){
		this.setState({ isSaving: false })
		if(response.status !== 'OK'){

			this.props.setModalContent({
				title: this.getTrad('messageFromServer'),
				body: [this.getTrad(response.message)],
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
				]
			});

			$("#exampleModal").modal('toggle');

		}else{
			this.props.setModalContent({
				title: this.getTrad('messageFromServer'),
				body: ['La delegación ha sido creada satisfactoriamente.'],
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
				]
			});

			$("#exampleModal").modal('toggle');
		}
    }

    handleChange(event) {

		let locationMod = this.state.location?{...this.state.location}:{};
		locationMod[event.target.name] = event.target.value;

		this.setState(prevState => {
			return {
			...prevState,
			location: locationMod
		}});
    }

    render() {
        return (
            <div className="container">
            	<Menu />
                <h3>{this.state.action === 'new'?this.getTrad('locationInsertion'):this.getTrad('locationEdition')}</h3>
                <div className="row mt-4">
			<div className="col-12">
			
			{(this.state.location || this.state.action === 'new')?
				<form>
				  
				  <div className="form-group">
				    <label htmlFor="name">Nombre</label>
				    <input type="text" className="form-control" id="name" name="name"
				    defaultValue={this.state.location?this.state.location.name:''} onChange={this.handleChange} />
				  </div>
				  
				  <div className="d-flex justify-content-between align-items-center mb-2">
					  <button type="button" className="btn btn-primary" onClick={this.saveButton} disabled={this.state.isSaving}>{this.state.isSaving ? 'Guardando...' : 'Guardar'}</button>
					  <button type="button" className="btn btn-secondary" onClick={this.cancelButton}>Cancelar</button>
				  </div>
				</form>

			:<span>La delegación no existe</span>}

			</div>
                </div>
			<Modal />
            </div>
        );
    }

    cursorPointer = {
	cursor: 'pointer',
	width: '100%',
	background: '#CCC',
	padding:'3px',
	fontWeight: 'bold',
	textAlign: 'center'
    }
}

const mapStateToProps = state => {
    return {
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setModalContent(modalContent){
	    	dispatch(setModalContent(modalContent));
		}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditLocation)
